import React from "react"
import "../Css_files/career_c2.css"

const OnlineCourses = () => {
  const courses = [
    {
      id: 1,
      name: "Mechanical Engineering",
      icon: "⚙️",
      description: "Learn mechanical design, robotics, and automation with hands-on projects.",
      skills: ["CAD Design", "CAM", "Robotics", "Manufacturing"],
      enrolled: "12K+",
    },
    {
      id: 2,
      name: "Civil Engineering",
      icon: "🏗️",
      description: "Master sustainable infrastructure and smart city design techniques.",
      skills: ["Smart Cities", "Infrastructure", "Urban Planning", "Sustainability"],
      enrolled: "8K+",
    },
    {
      id: 3,
      name: "Electronics & Communication",
      icon: "📡",
      description: "Build next-gen communication systems and IoT solutions.",
      skills: ["5G Technology", "IoT Systems", "Signal Processing", "Wireless Networks"],
      enrolled: "15K+",
    },
    {
      id: 4,
      name: "Electronics Engineering",
      icon: "🔌",
      description: "Create innovative electronic circuits and embedded systems.",
      skills: ["Circuit Design", "PCB Development", "Microcontrollers", "Power Systems"],
      enrolled: "10K+",
    },
    {
      id: 5,
      name: "Computer Science",
      icon: "💻",
      description: "Develop software, AI systems, and cloud-based applications.",
      skills: ["Full Stack Development", "AI/ML", "Python", "Web Development"],
      enrolled: "25K+",
    },
    {
      id: 6,
      name: "Arts & Multimedia",
      icon: "🎨",
      description: "Learn UI/UX, 3D modeling, animation, and digital art skills.",
      skills: ["UI/UX Design", "3D Modeling", "Animation", "Digital Art"],
      enrolled: "7K+",
    },
  ]

  return (
    <section className="career-departments" id="courses-section">
      <div className="career-departments-container">
        <div className="career-departments-header">
          <h2 className="career-departments-title">Our Courses</h2>
          <p className="career-departments-subtitle">
            Explore online courses across multiple engineering and creative disciplines
          </p>
        </div>

        <div className="career-departments-grid">
          {courses.map((course) => (
            <div key={course.id} className="career-department-card">
              <div className="career-department-card-header">
                <div className="career-department-icon">{course.icon}</div>
                <div className="career-department-openings">{course.enrolled} enrolled</div>
              </div>

              <h3 className="career-department-name">{course.name}</h3>
              <p className="career-department-description">{course.description}</p>

              <div className="career-department-specialties">
                {course.skills.map((skill, index) => (
                  <span key={index} className="career-department-specialty-tag">
                    {skill}
                  </span>
                ))}
              </div>

              <button className="career-department-btn">Enroll Now</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OnlineCourses
